import { FC } from 'react';
import { useNavigation } from '@/navigation/NavigationContex';

export const ProgressBar: FC = () => {
  const navigation = useNavigation();

  return (
    <>
      <div className="progress-bar-background">
        <div className="progress-bar-filling" style={{ width: navigation.progress * 100 + '%' }}></div>
      </div>
    </>
  );
};
